import { ImageProps } from 'next/dist/client/image'
import React, { FC, useState } from 'react'

import { ColorOverlay } from '@Components/Cloudinary/ColorOverlay'
import { ImageV2 } from '@Components/Image'

interface Props {
  greyOverlay: boolean
  hoverImageURL?: string | null
  imageURL?: string
  personalization: boolean
  title: string
}

const ProductTileImage: FC<Props> = ({ greyOverlay, hoverImageURL, imageURL, personalization, title }) => {
  const [hover, setHover] = useState(false)
  const imageOptions: Omit<ImageProps, 'src'> = {
    objectFit: personalization ? 'contain' : 'inherit',
    sizes: '(max-width: 768px) 50vw, (max-width: 1024px) 25vw, 235px',
    loading: 'lazy',
    layout: 'responsive',
    alt: title,
    height: 235,
    width: 235,
  }

  return (
    <ColorOverlay
      active={greyOverlay}
      onMouseOut={hoverImageURL?.length ? () => setHover(false) : undefined}
      onMouseOver={hoverImageURL?.length ? () => setHover(true) : undefined}
    >
      {!hover && imageURL?.length && <ImageV2 src={imageURL} {...imageOptions} />}
      {hover && hoverImageURL?.length && <ImageV2 src={hoverImageURL} {...imageOptions} />}
    </ColorOverlay>
  )
}

export default ProductTileImage
